import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { get } from "./Reducers/actions";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";

// Constants buiten component voor betere performance
const BADGE_CONFIGS = {
  SMS: { field: "SmsAuth" },
  Email: { field: "isVerified" },
  Actief: { field: "blocked", invert: true },
};

// Herbruikbare StatusBadge component
const StatusBadge = React.memo(({ text, status }) => (
  <span className={`badge-status ${status ? "active" : "inactive"}`}>
    <span>●</span> {text}
  </span>
));

const GebruikersPage = ({ get, gebruikers = [] }) => {
  // Combined effect voor mount en cleanup
  useEffect(() => {
    get();
  }, [get]);

  // Memoized columns definition
  const columns = useMemo(
    () => [
      { dataField: "voornaam", text: "Voornaam" },
      { dataField: "achternaam", text: "Achternaam" },
      { dataField: "email", text: "E-mail" },
      { dataField: "role", text: "Role" },
      {
        dataField: "isVerified",
        text: "Status",
        formatter: (_, row) => (
          <div className="status-badges">
            {Object.entries(BADGE_CONFIGS).map(([text, config]) => (
              <StatusBadge key={text} text={text} status={config.invert ? !row[config.field] : row[config.field]} />
            ))}
          </div>
        ),
        headerStyle: () => ({ width: "160px", textAlign: "center" }),
        style: { textAlign: "center", verticalAlign: "middle", padding: "8px" },
      },
      {
        text: "Acties",
        dataField: "_id",
        formatter: (_, row) => (
          <Link className="btn btn-primary btn-sm" to={`/admin/gebruikers/${row._id}`}>
            <i className="fa fa-edit"></i> Wijzigen
          </Link>
        ),
        headerStyle: () => ({ width: "150px" }),
      },
    ],
    []
  );

  const { SearchBar } = Search;

  return (
    <>
      <style>{`
        .badge-status {
          display: inline-flex;
          align-items: center;
          gap: 2px;
          padding: 2px 6px;
          border-radius: 8px;
          font-size: 9px;
          font-weight: 500;
          min-width: 45px;
          justify-content: center;
          border: 1px solid;
          text-transform: uppercase;
          letter-spacing: 0.3px;
          margin: 0 2px;
        }
        .badge-status.active {
          background-color: #d4edda;
          color: #155724;
          border-color: #c3e6cb;
        }
        .badge-status.inactive {
          background-color: #f8d7da;
          color: #721c24;
          border-color: #f5c6cb;
        }
        .badge-status span { font-size: 8px; }
        .status-badges {
          display: flex;
          flex-wrap: wrap;
          gap: 3px;
          justify-content: center;
          min-width: 140px;
        }
        .dropdown-item:hover {
          background-color: #f8f9fa;
        }
      `}</style>

      <div className="box box-default">
        <div className="box-header with-border">
          <h3 className="box-title">
            <i className="fa fa-users" /> Overzicht gebruikers
          </h3>
          <div className="box-tools pull-right">
            <Link className="btn-primary btn btn-box-too btn-sm" to="/admin/signup">
              <i className="fa fa-plus" /> Gebruiker Toevoegen
            </Link>
          </div>
        </div>

        <div className="col-md-12 no-float">
          <div className="box box-primary">
            <div className="box-body box-profile" />
            <ToolkitProvider keyField="_id" data={gebruikers} columns={columns} search={{ searchFormatted: true }}>
              {(props) => (
                <div>
                  <SearchBar placeholder="Zoeken" {...props.searchProps} />
                  <hr />
                  <BootstrapTable wrapperClasses="table-responsive-md" pagination={paginationFactory()} style={{ overflow: "visible" }} classes="table-dropdown-fix" {...props.baseProps} />
                </div>
              )}
            </ToolkitProvider>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ auth, gebruikers }) => ({
  username: auth.user,
  gebruikers: gebruikers.items,
});

export default connect(mapStateToProps, { get })(GebruikersPage);
